module.exports = __webpack_public_path__ + "img/mv02.69c2e8dd.png";